module.exports = __webpack_public_path__ + "assets/img/nav_bg3.67279b8a.png";